import { graphql } from '../../graphql/generated';

export const UPDATE_AI_SETTINGS_MUTATION = graphql(`
  mutation UpdateAiSettings($input: AiSettingsInput!) {
    updateAiSettings(input: $input) {
      id
    }
  }
`);

export const AI_SETTINGS_QUERY = graphql(`
  query AiSettings {
    aiSettings {
      id
      baseSystemPrompt
      temperature
      maxTokens
    }
  }
`);
